// @flow
import Vue from 'vue'

export default {
  setConfig(state, payload: { config: Object }) {
    state.color = payload.config.color
    state.version = _.extend({}, state.version || {}, payload.config.version)
    state.name = payload.config.name || window.location.host
    state.env = _.extend({}, state.env || {}, payload.config.env)

    // arrays need to be made reactive prior to update
    Vue.set(state, 'features', [...(payload.config.features || [])])
  },
  setStellerVersion(state, stellerVersion) {
    state.version = _.extend({}, state.version || {}, { steller: stellerVersion })
  }
}
